import React, { useMemo, useState } from 'react'
import Text from '@embracesbs/component-text'
import TabGroup from '@embracesbs/component-tabgroup/TabGroup'
import SectionCard from '../Common/SectionCard'
import { useSubscriptions } from '../Context/SubscriptionContext'

// Middle-panel view for a selected subscription (no tenant selected yet).
// Mirrors the TenantDetails layout: a 52px tab band + a scrollable content area.
const SubscriptionDetails: React.FC = () => {
  const { selectedSubscription } = useSubscriptions()
  const [selectedTab, setSelectedTab] = useState('Overview')

  const tabs = useMemo(
    () => [
      {
        id: 'Overview',
        text: 'Overview'
      }
    ],
    []
  )

  const renderDetailsContent = useMemo(() => {
    switch (selectedTab) {
      case 'Overview':
        return (
          <SectionCard title='Overview'>
            <Text
              textStyle='body'
              textColor='grey'
              content={`Subscription overview for ${selectedSubscription?.customerName ?? '…'} — coming soon.`}
            />
          </SectionCard>
        )
      default:
        return <div>Not yet implemented</div>
    }
  }, [selectedTab, selectedSubscription])

  return (
    <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          flexShrink: 0,
          height: '52px',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          marginLeft: '-40px',
          marginRight: '-40px'
        }}
      >
        <TabGroup
          onTabClick={(id: string) => setSelectedTab(id)}
          tabs={tabs}
          activeKey={selectedTab}
          canTabsGrow
          hasFullWidthBorder
          spacing={{ top: 0, bottom: 0 }}
        />
      </div>
      {/* Bleed to the panel edge so the scrollbar sits flush right; the padding gives the content its 40px back. */}
      <div
        style={{ flex: 1, minHeight: 0, overflowY: 'auto', marginTop: '12px', marginRight: '-40px', paddingRight: '40px' }}
        className='custom-scrollbar'
      >
        {renderDetailsContent}
      </div>
    </div>
  )
}

export default SubscriptionDetails
